import { TransactionListItem } from "@common/schemas/transaction.schema";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { LedgerCell } from "./LedgerCell";

export const AccrualLedgerCell = memo(
    (props: CellContext<ViewTableFeatures, TransactionListItem, any>) => (
        <LedgerCell {...props} basis={AccountingLedgerBasis.accruals} />
    ),
);

AccrualLedgerCell.displayName = "AccrualLedgerCell";
